<template>
	<div style="width:800px; height:610px;" v-on:keyup.esc="close()">
		<div class="view_inner">
			<div style="height: 530px; overflow-y: auto; overflow-x: hidden;">
				<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable border="0">
					<thead>
						<tr>
							<th style="text-align:center;width:160px;">CRT Datetime</th>
							<th style="text-align:center;width:100px;">Shipment No</th>
							<th style="text-align:center;width:90px;">Exp Date</th>
							<th style="text-align:center;width:90px;">Init Qty</th>
							<th style="text-align:center;width:90px;">Cur Qty</th>
							<th style="text-align:center;width:120px;">Location</th>
							<th style="text-align:center;">BIN</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="lot in lots" v-bind:key="lot.lot_no">
							<td>{{ lot.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
							<td>{{ lot.sh_dn }}</td>
							<td class="al_left">{{ lot.exp_date }}</td>
							<td class="al_right">{{ lot.initial_quantity | commaSeparated }}</td>
							<td class="al_right">{{ lot.on_hand | commaSeparated }}</td>
							<td>
								<!-- {{ lot.location_code }}  -->
								<template v-if="lot.location_code">{{ lot.location_name }}</template>
							</td>
							<td>{{ lot.bin }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Close</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import { apiSelectLotList } from '@/api/item/inventory.js';

export default {
	data: function() {
		return {
			lots: [],
		};
	},
	props: {
		item_id: String,
	},
	components: {},
	methods: {
		async selectLotList() {
			const { data } = await apiSelectLotList({
				paging_yn: 'N',
				item_id: this.item_id,
			});
			this.lots = data.lotList;
		},
		async init() {
			await this.selectLotList();
		},

		close() {
			this.$emit('close');
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
